import React from 'react';
import { IonIcon, IonLabel, IonImg, IonBadge, IonAvatar } from '@ionic/react';

import './HeaderApp.css';
import { star, today} from 'ionicons/icons';
import { RouteComponentProps } from 'react-router';
import { isPlatform } from '@ionic/react';

interface HeaderAppProps extends RouteComponentProps {
  pinValue: number;
  recentValue: number;
  isOnline: boolean;
}


const HeaderApp: React.FC<HeaderAppProps> = ({ pinValue, recentValue, isOnline, history, location, match }) => {
  const harborName =  window.localStorage.getItem("defaultClientName") ? String(window.localStorage.getItem("defaultClientName")) : "";
  const logoClick = () => {
    history.push("/home");
  }
  
  const userClick = () => {
    history.push("/logout");
  }

  return (
        // <IonGrid className={isPlatform('ios') ? "my-toolbar-ios" : "my-toolbar"}>
        //   <IonRow>
        //     <IonCol size="2" className="ion-align-self-left"> 
        //       <IonImg className="my-app-logo" src={"assets/images/logo_sign_white.png"} onClick={logoClick}/> 
        //     </IonCol>
        //     <IonCol size="4" className="ion-align-self-center"> 
        //       <IonLabel mode="ios" className="my-header-label">{harborName}</IonLabel> 
        //     </IonCol>
        //     <IonCol size="2" className="ion-align-self-center">
        //       <IonBadge mode="ios" className="my-badge" onClick={() => {history.push("/recentresults")}}>
        //           <IonIcon mode="ios" className="my-badge-icon" icon={today} color="primary" size="medium"/>
        //           <IonLabel mode="ios" className="my-badge-label" color="primary">{recentValue}</IonLabel>
        //       </IonBadge>
        //     </IonCol>
        //     <IonCol size="2" className="ion-align-self-center">
        //       <IonBadge mode="ios" className="my-badge" onClick={() => {history.push("/watchresults")}}>
        //           <IonIcon mode="ios" className="my-badge-icon" icon={star} color="primary" size="medium"/>
        //           <IonLabel mode="ios" className="my-badge-label" color="primary">{pinValue}</IonLabel>
        //       </IonBadge>
        //     </IonCol>
        //     <IonCol size="2" className="my-right-column">
        //         <IonAvatar className="my-avatar" onClick={userClick} style={{display: isOnline ? "block" : "none"}}>
        //           <img src={"assets/images/peopleNoBack.png"} alt=""/>
        //         </IonAvatar>
        //         <IonAvatar className="my-avatar" onClick={userClick} style={{display: isOnline ? "none" : "block"}}>
        //           <img src={"assets/images/peopleNoBackOffline.png"} alt=""/>
        //         </IonAvatar>
        //     </IonCol>
        //   </IonRow> 
        //   {/* {!isOnline &&
        //     <IonRow className="my-offline-row">
        //        <IonCol size="9"></IonCol>
        //       <IonCol size="3"> 
        //         <IonLabel mode="ios" className="my-offline-label" color="danger">Offline Mode</IonLabel>
        //       </IonCol>
        //     </IonRow> 
        //   } */}
        // </IonGrid>
        <div className={isPlatform('ios') ? "my-toolbar-app-ios" : "my-toolbar-app"}>
          <IonImg className="my-app-logo" src={"assets/images/logo_sign_white.png"} onClick={logoClick}/> 
          <IonLabel mode="ios" className="my-header-label">{harborName}</IonLabel> 
          <IonBadge mode="ios" className="my-badge" onClick={() => {history.push("/recentresults")}}>
            <IonIcon mode="ios" className="my-badge-icon" icon={today} color="primary" size="medium"/>
            <IonLabel mode="ios" className="my-badge-label" color="primary">{recentValue}</IonLabel>
          </IonBadge>
          <IonBadge mode="ios" className="my-badge" onClick={() => {history.push("/watchresults")}}>
            <IonIcon mode="ios" className="my-badge-icon" icon={star} color="primary" size="medium"/>
            <IonLabel mode="ios" className="my-badge-label" color="primary">{pinValue}</IonLabel>
          </IonBadge>
          <IonAvatar className="my-avatar" onClick={userClick} style={{display: isOnline ? "block" : "none"}}>
            <img src={"assets/images/peopleNoBack.png"} alt=""/>
          </IonAvatar>
          <IonAvatar className="my-avatar" onClick={userClick} style={{display: isOnline ? "none" : "block"}}>
            <img src={"assets/images/peopleNoBackOffline.png"} alt=""/>
          </IonAvatar>
        </div>
  );
};

export default HeaderApp;
